// ReportDisplay.tsx
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'; // Import Recharts for Pie Chart

// Component for rendering a pie chart
const ReportPieChart: React.FC<{ data: any[] }> = ({ data }) => {
    const chartData = data.map((item) => ({
        name: item.name, // Adjust the property names based on your data structure
        value: item.value,
    }));

    return (
        <ResponsiveContainer width="100%" height={300}>
            <PieChart>
                <Pie data={chartData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} fill="#8884d8">
                    {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.value > 50 ? '#82ca9d' : '#ff6384'} />
                    ))}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
};

export default ReportPieChart;
